import type { ReactNode, HTMLAttributes, RefObject } from 'react';

type ContainerProps = {
	ref?: RefObject<HTMLDivElement | null>;
	children: ReactNode;
	className?: string;
	gap?: string;
	style?: any;
} & HTMLAttributes<HTMLDivElement>;

const Container = ({ children, className, ...props }: ContainerProps) => {
	return <div className={className} {...props}>{children}</div>;
};

export const FlexCenterContainer = ({
	children,
	className,
	...props
}: ContainerProps) => {
	return (
		<div
			className={`flex justify-content-center align-items-center ${className}`}
			{...props}
		>
			{children}
		</div>
	);
};

export const CenterContent = ({ children, className, ...props }: ContainerProps) => {
	return <div className={`m-auto ${className}`} {...props}>{children}</div>;
};

export const FlexCenterContent = ({ children, className, ...props }: ContainerProps) => {
	return <div className={`flex items-center justify-center ${className}`} {...props}>{children}</div>;
};

export const FlexSpaceBetweenContainer = ({
	children,
	className,
	...props
}: ContainerProps) => {
	return (
		<div
			className={`${className} flex flex-row w-full justify-between items-center`}
			{...props}
		>
			{children}
		</div>
	);
};

export const Column = ({ ref, children, gap = '', className = '', style, ...props }: ContainerProps) => {
	const classes = ['flex', 'flex-col', gap, className]
		.filter(Boolean)
		.join(' ');
	return <div className={classes} style={style} {...props}>{children}</div>;
};

export const Row = ({ children, gap = '', className = '', style, ...props }: ContainerProps) => {
	const classes = ['flex', 'flex-row', gap, className]
		.filter(Boolean)
		.join(' ');
	return <div className={classes} style={style} {...props}>{children}</div>;
};

export const FlexWrap = ({ children, gap = '', className = '', style, ...props }: ContainerProps) => {
	const classes = ['flex', 'flex-wrap', gap, className]
		.filter(Boolean)
		.join(' ');
	return <div className={classes} style={style} {...props}>{children}</div>;
};

export default Container;
